import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/blog/[id]/components/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/services/[id]/components/DynamicDesc.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/SeeMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/ui/slider.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
